import { render, staticRenderFns } from "./LControlFloors.vue?vue&type=template&id=1ef739fc&scoped=true&"
import script from "./LControlFloors.vue?vue&type=script&lang=js&"
export * from "./LControlFloors.vue?vue&type=script&lang=js&"
import style0 from "./LControlFloors.vue?vue&type=style&index=0&id=1ef739fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef739fc",
  null
  
)

export default component.exports